import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import CountUp from "@/components/CountUp";

const ease = [0.16, 1, 0.3, 1];

const STATS = [
  { value: 80, decimals: 0, prefix: "$", suffix: "B+", label: "Global TAM", note: "Global live events & ticket market, annually" },
  { value: 2.1, decimals: 1, prefix: "$", suffix: "B+", label: "Boston SAM", note: "Boston live event spend, largely underserved locally" },
  { value: 250, decimals: 0, prefix: "", suffix: "K+", label: "Students", note: "College students in the Boston metro" },
  { value: 6.2, decimals: 1, prefix: "$", suffix: "B", label: "Boston Market", note: "Metro live events & entertainment market" },
];

const Stats = () => (
  <section data-testid="stats-section" className="bg-charcoal-900 py-16 sm:py-20">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            data-testid={`stat-card-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: i * 0.08, ease }}
          >
            <div className="font-mono text-4xl font-semibold tracking-tight text-white sm:text-5xl">
              <CountUp to={s.value} decimals={s.decimals} prefix={s.prefix} suffix={s.suffix} dark />
            </div>
            <div className="mt-3 font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-violet-400">{s.label}</div>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.note}</p>
          </motion.div>
        ))}
      </div>
      <Reveal className="mt-14 border-t border-white/10 pt-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
          Source: True Life Entertainment Executive Business Plan, Boston, Massachusetts, June 2026
        </p>
      </Reveal>
    </div>
  </section>
);

export default Stats;
